import { fetch } from '@/utils/fetch'
import { memoryCache } from '@/utils/cache'
import { getQuery } from '@/utils/query'
import { ServiceResponse } from 'loca-boot-core'
import { ConfigModel } from '../models/config.model'
import CryptoJS from 'crypto-js'

/**
 * 获取H5系统配置参数
 * https://apidoc.nioint.com/project/10079/interface/api/785518
 * @param {string} [code] 参数code；多个以,隔开，不传返回全部
 */
export const getConfigs = memoryCache(function getConfigs(codes?: string) {
  return fetch.get('charge-map/v2/configs/dictionary', {
    params: { codes },
  })
})

/**
 * 获取组件配置接口
 * https://apidoc.nioint.com/project/10079/interface/api/785564
 */
export const getComponentsConfig = async () => {
  const res = await fetch.get('/charge-map/v2/component/config')
  const config: any = {}
  if (res.isValid() && res.data) {
    const decryptData = new ServiceResponse<ConfigModel>(
      {
        data: res.encryptType === 1 ? JSON.parse(decrypt(res.data)) : res.data,
      },
      ConfigModel
    ).data
    const cp = decryptData?.components
    if (cp?.length < 1) return {}
    cp.forEach((el: { id: string | number; name: any; show: any; properties: any }) => {
      config[el.id] = {
        name: el.name,
        show: el.show,
        properties: el.properties,
      }
    })
  }
  if (config?.wishpower?.show) {
    // 从URL中读取配置
    const defaultWishPowerConfig = {
      map_level: [7.5, 12],
      cluster_radius: [22000, 10000, 3000],
      base_size: 0,
      zoom_rate: 4,
      size: [4, 6, 10],
      colors: ['#A9EEEC', '#74E2DF', '#37D1CC', '#00BEBE', '#146482'],
      max: [100, 100, 100],
      min: [0, 0, 0],
    }
    config.wishpower.properties = Object.assign(
      {},
      defaultWishPowerConfig,
      config.wishpower.properties,
      getConfigFromUrl()
    )
  }
  return { res, config }
}

/**
 * 从URL中读取配置
 * @returns
 */
export const getConfigFromUrl = () => {
  const querys = getQuery() as any
  const urlConfig = {} as any
  let level = 1
  if (querys['map_level']) {
    const temp = querys['map_level'].split(',').map((val: string) => Number(val))
    temp.length >= 0 && (urlConfig.map_level = temp)
    level = 1 + temp.length
  }
  if (querys['cluster_radius']) {
    const temp = querys['cluster_radius'].split(',').map((val: string) => Number(val))
    temp.length == level && (urlConfig.cluster_radius = temp)
  }
  if (querys['base_size']) {
    const temp = Number(querys['base_size'])
    temp > 0 && (urlConfig.base_size = temp)
  }
  if (querys['zoom_rate']) {
    const temp = Number(querys['zoom_rate'])
    temp > 0 && (urlConfig.zoom_rate = temp)
  }
  if (querys['size']) {
    const temp = querys['size'].split(',').map((val: string) => Number(val))
    temp.length == level && (urlConfig.size = temp)
  }
  if (querys['colors']) {
    const temp = querys['colors'].split(',').map((val: string) => decodeURIComponent(val))
    temp.length == 5 && (urlConfig.colors = temp)
  }
  if (querys['max']) {
    const temp = querys['max'].split(',').map((val: string) => Number(val))
    temp.length == level && (urlConfig.max = temp)
  }
  if (querys['min']) {
    const temp = querys['min'].split(',').map((val: string) => Number(val))
    temp.length == level && (urlConfig.min = temp)
  }
  return urlConfig
}

export const decrypt = (data: any) => {
  const key = CryptoJS.enc.Utf8.parse('fqsxxsWbKWkSlNaw')
  const iv = CryptoJS.enc.Utf8.parse('/eVWenuz1/tmHiPd')
  const encryptedHexStr = CryptoJS.enc.Base64.parse(data)
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  const decrypted = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })
  const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}
